import React from 'react';
import { motion } from 'framer-motion';

const EditorialMarquee = () => {
  const marqueeItems = [
    'Highest Industry Earnings',
    '100% Discreet & Anonymous',
    'Safe & Regulated Venues',
    'Flexible Shifts',
    'Melbourne CBD & Suburbs',
    'Professional Support',
    'Legal Framework',
    'Your Choice, Your Terms',
  ];

  return (
    <section 
      className="relative py-8 bg-[#121216] border-y border-[rgba(255,255,255,0.06)] overflow-hidden"
      data-testid="editorial-marquee"
    >
      <div className="flex">
        {/* First marquee track */}
        <motion.div
          className="flex shrink-0 gap-0 animate-marquee"
          style={{ willChange: 'transform' }}
        >
          {[...marqueeItems, ...marqueeItems].map((item, index) => (
            <div key={index} className="flex items-center shrink-0">
              <span className="marquee-text whitespace-nowrap px-4">
                {item}
              </span>
              <span className="marquee-separator">◆</span>
            </div>
          ))}
        </motion.div>
        
        {/* Duplicate for seamless loop */}
        <motion.div
          className="flex shrink-0 gap-0 animate-marquee"
          style={{ willChange: 'transform' }}
        >
          {[...marqueeItems, ...marqueeItems].map((item, index) => (
            <div key={`dup-${index}`} className="flex items-center shrink-0">
              <span className="marquee-text whitespace-nowrap px-4">
                {item}
              </span>
              <span className="marquee-separator">◆</span>
            </div>
          ))}
        </motion.div>
      </div>

      {/* Gradient fades on edges */}
      <div className="absolute left-0 top-0 bottom-0 w-20 bg-gradient-to-r from-[#121216] to-transparent z-10" />
      <div className="absolute right-0 top-0 bottom-0 w-20 bg-gradient-to-l from-[#121216] to-transparent z-10" />
    </section>
  );
};

export default EditorialMarquee;
